"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleTypeCodeReverseMapper = exports.TitleTypeCodeMapper = exports.TitleTypeCode = void 0;
// These need to be the exact strings that are stored in an AD User's internalContact.title field
// TODO: Review role 'Auto Approved' in future sprint as Auto Approve should be mapped to an HBT concept instead of a role
var TitleTypeCode;
(function (TitleTypeCode) {
    TitleTypeCode[TitleTypeCode["ARREARS_SPECIALIST"] = 5] = "ARREARS_SPECIALIST";
    TitleTypeCode[TitleTypeCode["ARREARS_MANAGER"] = 6] = "ARREARS_MANAGER";
    TitleTypeCode[TitleTypeCode["AUTO_APPROVED"] = 10] = "AUTO_APPROVED";
    TitleTypeCode[TitleTypeCode["SENIOR_OFFICER"] = 20] = "SENIOR_OFFICER";
    TitleTypeCode[TitleTypeCode["SPECIALIST"] = 30] = "SPECIALIST";
    TitleTypeCode[TitleTypeCode["MANAGER"] = 40] = "MANAGER";
    TitleTypeCode[TitleTypeCode["SENIOR_SPECIALIST"] = 50] = "SENIOR_SPECIALIST";
    TitleTypeCode[TitleTypeCode["DIRECTOR"] = 60] = "DIRECTOR";
    TitleTypeCode[TitleTypeCode["VICE_PRESIDENT"] = 70] = "VICE_PRESIDENT";
    TitleTypeCode[TitleTypeCode["SENIOR_VICE_PRESIDENT"] = 80] = "SENIOR_VICE_PRESIDENT";
    TitleTypeCode[TitleTypeCode["PRESIDENT"] = 90] = "PRESIDENT";
})(TitleTypeCode = exports.TitleTypeCode || (exports.TitleTypeCode = {}));
exports.TitleTypeCodeMapper = {
    'Specialist, Quality Assurance Analysis': TitleTypeCode.ARREARS_SPECIALIST,
    "Spécialiste, Analyse de l'assurance de la qualité": TitleTypeCode.ARREARS_SPECIALIST,
    'Manager, Operational Reporting': TitleTypeCode.ARREARS_MANAGER,
    'Gestionnaire, Rapports opérationnels': TitleTypeCode.ARREARS_MANAGER,
    'Auto Approved': TitleTypeCode.AUTO_APPROVED,
    'Auto-approuvée': TitleTypeCode.AUTO_APPROVED,
    'Senior Officer, Operations': TitleTypeCode.SENIOR_OFFICER,
    'Agent principal, Opérations': TitleTypeCode.SENIOR_OFFICER,
    'Specialist, Default Management and Claims': TitleTypeCode.SPECIALIST,
    'Spécialiste, Gestion des cas de défaut et demandes de règlement': TitleTypeCode.SPECIALIST,
    'Manager, Programs': TitleTypeCode.MANAGER,
    'Gestionnaire, Programmes': TitleTypeCode.MANAGER,
    'Senior Specialist, Claims and Recoveries': TitleTypeCode.SENIOR_SPECIALIST,
    'Spécialiste principal, Demandes de Règlements et recouvrements': TitleTypeCode.SENIOR_SPECIALIST,
    'Director, Homeowner Operations': TitleTypeCode.DIRECTOR,
    'Directeur, Opérations – Logements pour propriétaires-occupants': TitleTypeCode.DIRECTOR,
    'Vice-President, Operations': TitleTypeCode.VICE_PRESIDENT,
    'Vice-président, Opérations': TitleTypeCode.VICE_PRESIDENT,
    'Senior Vice-President, Client Operations': TitleTypeCode.SENIOR_VICE_PRESIDENT,
    'Premier vice-président, Opérations clients': TitleTypeCode.SENIOR_VICE_PRESIDENT,
    'President & CEO': TitleTypeCode.PRESIDENT,
    'Président et premier dirigeant': TitleTypeCode.PRESIDENT,
};
exports.TitleTypeCodeReverseMapper = (_a = {},
    _a[TitleTypeCode.ARREARS_SPECIALIST] = {
        en: 'Specialist, Quality Assurance Analysis',
        fr: "Spécialiste, Analyse de l'assurance de la qualité",
    },
    _a[TitleTypeCode.ARREARS_MANAGER] = {
        en: 'Manager, Operational Reporting',
        fr: 'Gestionnaire, Rapports opérationnels',
    },
    _a[TitleTypeCode.AUTO_APPROVED] = {
        en: 'Auto Approved',
        fr: 'Auto-approuvée',
    },
    _a[TitleTypeCode.SENIOR_OFFICER] = {
        en: 'Senior Officer, Operations',
        fr: 'Agent principal, Opérations',
    },
    _a[TitleTypeCode.SPECIALIST] = {
        en: 'Specialist, Default Management and Claims',
        fr: 'Spécialiste, Gestion des cas de défaut et demandes de règlement',
    },
    _a[TitleTypeCode.MANAGER] = {
        en: 'Manager, Programs',
        fr: 'Gestionnaire, Programmes',
    },
    _a[TitleTypeCode.SENIOR_SPECIALIST] = {
        en: 'Senior Specialist, Claims and Recoveries',
        fr: 'Spécialiste principal, Demandes de Règlements et recouvrements',
    },
    _a[TitleTypeCode.DIRECTOR] = {
        en: 'Director, Homeowner Operations',
        fr: 'Directeur, Opérations – Logements pour propriétaires-occupants',
    },
    _a[TitleTypeCode.VICE_PRESIDENT] = {
        en: 'Vice-President, Operations',
        fr: 'Vice-président, Opérations',
    },
    _a[TitleTypeCode.SENIOR_VICE_PRESIDENT] = {
        en: 'Senior Vice-President, Client Operations',
        fr: 'Premier vice-président, Opérations clients',
    },
    _a[TitleTypeCode.PRESIDENT] = {
        en: 'President & CEO',
        fr: 'Président et premier dirigeant',
    },
    _a);
